import { DEFAULT_TICKETING_FORM_KEY } from './ticketingStorage';

export const TICKETING_FORM_KEY = {
  HR_EMPLOYEE_IT: 'hr_employee_it',
  HR_EMPLOYEE_EDIT_IT: 'hr_employee_edit_it',
  HR_EMPLOYEE_DELETE_IT: 'hr_employee_delete_it',
  WAREHOUSE_ACCESS: 'warehouse_access',
  GENERAL: 'general_request',
  GENERAL_IT: 'general_it',
};

/** All HR employee lifecycle forms share payload shape (date field key differs). */
export const HR_EMPLOYEE_FORM_KEYS = [
  TICKETING_FORM_KEY.HR_EMPLOYEE_IT,
  TICKETING_FORM_KEY.HR_EMPLOYEE_EDIT_IT,
  TICKETING_FORM_KEY.HR_EMPLOYEE_DELETE_IT,
];

export function isHrEmployeeFormKey(formKey) {
  return HR_EMPLOYEE_FORM_KEYS.includes(formKey);
}

/** Labels for setup UI (category form template). */
export const TICKETING_FORM_OPTIONS = [
  { value: TICKETING_FORM_KEY.HR_EMPLOYEE_IT, label: 'HR — Add employee (IT resources)' },
  { value: TICKETING_FORM_KEY.HR_EMPLOYEE_EDIT_IT, label: 'HR — Edit employee (IT resources)' },
  { value: TICKETING_FORM_KEY.HR_EMPLOYEE_DELETE_IT, label: 'HR — Delete employee (IT resources)' },
  { value: TICKETING_FORM_KEY.WAREHOUSE_ACCESS, label: 'Warehouse — access & equipment' },
  { value: TICKETING_FORM_KEY.GENERAL, label: 'General — description, urgency, impact' },
  { value: TICKETING_FORM_KEY.GENERAL_IT, label: 'General IT — HW/SW/other, urgency, impact' },
];

export const TICKETING_FORM_META = {
  [TICKETING_FORM_KEY.HR_EMPLOYEE_IT]: {
    successMessage: 'IT ticket created',
    requestHeading: 'New employee — IT request',
  },
  [TICKETING_FORM_KEY.HR_EMPLOYEE_EDIT_IT]: {
    successMessage: 'IT ticket created',
    requestHeading: 'Edit employee — IT request',
  },
  [TICKETING_FORM_KEY.HR_EMPLOYEE_DELETE_IT]: {
    successMessage: 'IT ticket created',
    requestHeading: 'Delete employee — IT request',
  },
  [TICKETING_FORM_KEY.WAREHOUSE_ACCESS]: {
    successMessage: 'Warehouse request submitted',
    requestHeading: 'Warehouse request',
  },
  [TICKETING_FORM_KEY.GENERAL]: {
    successMessage: 'Ticket submitted',
    requestHeading: 'General request',
  },
  [TICKETING_FORM_KEY.GENERAL_IT]: {
    successMessage: 'IT ticket submitted',
    requestHeading: 'General IT request',
  },
};

export function resolveCategoryFormKey(category) {
  if (!category) return DEFAULT_TICKETING_FORM_KEY;
  const k = category.formKey;
  if (typeof k === 'string' && k.trim()) return k.trim();
  return DEFAULT_TICKETING_FORM_KEY;
}

export function getTicketingFormMeta(formKey) {
  return TICKETING_FORM_META[formKey] || TICKETING_FORM_META[DEFAULT_TICKETING_FORM_KEY];
}
